const lstTypeDocument = [
    { value: '1', text: 'Cédula' },
    { value: '2', text: 'Pasaporte' },
    { value: '3', text: 'Residencia' },
]

const lstSearchFilter = [
    { value: '1', text: 'Identificación del asegurado' },
    { value: '2', text: 'Nombre del asegurado' },
    { value: '3', text: 'No. de oferta' },
]


const siteTitleMain: Array<string> = [
    '¡Calcula tu seguro de auto en minutos!',
    '¡Hola, $nom.bre_corrdr iniciemos con la oferta',
    '¡Hola, $nom.bre_corrdr iniciemos con la oferta',
    'Personalización de la cotización de auto',
    'Estás a un paso de generar la oferta',
    'Un último paso antes de tu oferta',
    '',
    '¡Hemos terminado! Descarga tu oferta'
]

const txtBack = 'Regresar';
const txtNext = 'Siguiente';
const txtSave = 'Generar oferta';


const lstPageTitle: Array<IPageInfo> = [
    {
        index: 0,
        indexBar: 0,
        title1: 'Datos de Corredor',
        title2: 'Espacios requeridos',
        title3: '¡Hola! Para poder identificarte, ingresa el tipo y el número de identificación',
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 1,
        indexBar: 1,
        title1: 'Antes de iniciar',
        title2: 'Espacios requeridos',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 2,
        indexBar: 2,
        title1: 'Detalles del vehículo',
        title2: 'Espacios requeridos',
        title3: '¡Empecemos! Primero ingresa los datos del vehículo a asegurar',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 3,
        indexBar: 2,
        title1: 'Selección de coberturas',
        title2: 'Espacios requeridos',
        title3: 'Ingrese toda la información relacionada al siniestro del vehículo asegurado',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 4,
        indexBar: 3,
        title1: 'Resultados de la tarificación',
        title2: 'Espacios requeridos',
        title3: 'Te presentamos el detalle de la prima del vehículo asegurar',
        txtBtnBack: txtBack,
        txtBtnNext: txtNext,
    } as IPageInfo,
    {
        index: 5,
        indexBar: 4,
        title1: 'Datos de tu cliente',
        title2: 'Espacios requeridos',
        title3: 'Ingresa los siguientes datos, según el   documento de identidad de tu cliente',
        txtBtnBack: txtBack,
        txtBtnNext: txtSave,
    } as IPageInfo,
    {
        index: 6,
        indexBar: 5,
        title1: '',
        title2: '',
        title3: '',
        txtBtnBack: '',
        txtBtnNext: '',
    } as IPageInfo,
]

const catOfferType: Array<ICatalog> = [
    { value: '1', text: 'Nueva Oferta' } as ICatalog,
    { value: '2', text: 'Recuperar Oferta' } as ICatalog,
]

const catVehicleBrand: Array<ICatalog> = [
    { value: '2', text: 'Nissan' } as ICatalog,
    { value: '11', text: 'Hyundai' } as ICatalog,
    { value: '1', text: 'Toyota' } as ICatalog,
    { value: '9', text: 'Suzuki' } as ICatalog,
    { value: '12', text: 'Mitsubishi' } as ICatalog,
    { value: '29', text: 'Kia' } as ICatalog,
    { value: '0', text: 'Otro' } as ICatalog,
]

const catVehicleStatus: Array<ICatalog> = [
    { value: '1', text: 'Nuevo' } as ICatalog,
    { value: '2', text: 'Usado' } as ICatalog,
]

const catVehicleDevice: Array<ICatalog> = [
    { value: '1', text: 'No posee dispositivo de rastreo' } as ICatalog,
    { value: '2', text: 'Tiene GPS' } as ICatalog,
    { value: '3', text: 'Tiene LowJack' } as ICatalog,
    { value: '4', text: 'Tiene ambos dispositivos' } as ICatalog,
]

const catCivilStatus: Array<ICatalog> = [
    { value: '1', text: 'Casado(a)', text2: 'C' } as ICatalog,
    { value: '2', text: 'Soltero(a)', text2: 'S' } as ICatalog,
    { value: '3', text: 'Divorciado(a)', text2: 'D' } as ICatalog,
    { value: '4', text: 'Viudo(a)', text2: 'V' } as ICatalog,
    { value: '5', text: 'Union Libre', text2: 'U' } as ICatalog,
]


const catGender: Array<ICatalog> = [
    { value: '1', text: 'Femenino' } as ICatalog,
    { value: '2', text: 'Masculino' } as ICatalog,
]



const customStyles: any = {
    option: (provided: any, state: any) => {
        return {
            ...provided,
            fontSize: '13px',
            padding: '4px 12px',
            backgroundColor: state.isSelected ? "#008964" : "white",

        }
    },
    indicatorSeparator: (provided: any, state: any) => { },
    indicatorsContainer: (provided: any, state: any) => {
        return {
            ...provided,
            height: 27,
            padding: 0,

        }
    },
    control: (provided: any, state: any) => {
        return {
            ...provided,
            minHeight: 35,
            border: "1px solid #e4e4e4",
            height: 30,
            width: "100%",
            fontSize: '13px',
            backgroundColor: '#f7f7f7',
            borderRadius: 0,
            borderColor: state.isFocused && "",
            boxShadow: 0,
            "text-align-last": "left",
            '&:hover': {
                border: '0 !important',
            },
            selectProps: {
                backgroundColor: "#008964",
            }
        }
    },
    menu: (provided: any, state: any) => {
        return {
            ...provided,
            borderRadius: 0,
        }
    },
    placeholder: (provided: any, state: any) => {
        return {
            ...provided,
            "text-align": "center",
        }
    },
    singleValue: (provided: any, state: any) => {
        return {
            ...provided,
            opacity: state.isDisabled ? 0.5 : 1,
            transition: 'opacity 300ms',
        }
    },
}

const term = "En cumplimiento con la Ley 7786 y la Política Conozca a su Cliente, declaro que este formulario ha sido completado por mí y/o en mi presencia o por medio de un intermediario de seguros autorizado por la SUGESE  según Art 20. Ley 8653,  que la información provista es fiel y verdadera, y  que he recibido la información completa del seguro a contratar y los alcances del Formulario indicado.   Asimismo, declaro que los recursos por movilizar a través del Grupo Financiero Lafise (en adelante G.F.L.) provienen de actividades lícitas. La información de este formulario puede ser utilizada por cualquiera de las empresas autorizadas del G.F.L. para los fines respectivos.";

const enum stepEnum {
    step1,
    step2,
    step3,
    step4,
    step5,
    step6,
    step7
}

const enum typeCobEnum {
    DEFAULT = 'DEFAULT',
    COMBO = 'COMBO',
    ESPECIAL_COB = 'ESPECIAL_COB'
}


const idDiscountManual: number = 2;
const idDiscountAutoNew: number = 5;

const coveragesSpecialEquipment: Array<number> = [54, 264]

export {
    lstTypeDocument,
    siteTitleMain,
    lstPageTitle,
    customStyles,
    catOfferType,
    lstSearchFilter,
    catVehicleBrand,
    catVehicleStatus,
    stepEnum,
    catVehicleDevice,
    coveragesSpecialEquipment,
    catCivilStatus,
    catGender,
    idDiscountManual,
    idDiscountAutoNew,
    typeCobEnum,
    term
};
